/** IDs must match settings app `custom_names_for_invoice[].id` */
export const INVOICE_CUSTOM_BUTTON_IDS = {
  ADD_INVOICE_MAILED: 'add_invoice_mailed_invoice',
  ADD_PO_BASED_MAILED: 'add_po_based_invoice_mailed_invoice',
  ADD_PO_BASED_REMOVED_MAILED: 'add_po_based_invoice_removed_mailed_invoice',
  ADD_INVOICE_REMOVED_MAILED: 'add_invoice_removed_mailed_invoice',
  ADD_INVOICE_SCREEN: 'add_invoice_screen',
  RAISE_INVOICE_MULTI_GRN: 'raise_invoice_multi_grn_invoice',
  RAISE_INVOICE_REJECTED: 'raise_invoice_rejected_invoice',
  ADD_GRN_VENDOR_DASHBOARD: 'add_grn_vendor_invoice_dashboard',
  ADD_INVOICE_VENDOR: 'add_invoice_vendor_portal',
  ADD_GRN_INVOICE_REJECTED_VENDOR: 'add_grn_invoice_vendor_portal_rejected',
  ADD_DIRECT_INVOICE_REJECTED_VENDOR: 'add_direct_invoice_vendor_portal_rejected',
};

/** Fallback ids if settings meta uses an older key */
const INVOICE_BUTTON_ID_ALIASES: { [key: string]: string[] } = {
  add_invoice_screen: ['add_invoice_add_invoice_screen'],
  add_invoice_vendor_portal: ['add_invoice_vendor_invoice', 'add_invoice_vendor_add_invoice'],
  add_grn_vendor_invoice_dashboard: ['add_grn_vendor_invoice', 'add_grn_invoice_vendor_dashboard'],
  add_grn_invoice_vendor_portal_rejected: [
    'add_grn_invoice_rejected_vendor',
    'add_grn_invoice_rejected_vendor_invoice',
  ],
  add_direct_invoice_vendor_portal_rejected: [
    'add_direct_invoice_rejected_vendor',
    'add_direct_invoice_rejected_vendor_invoice',
  ],
};

function normalizeCustomNamesList(companySetup?: any): any[] {
  const setup = companySetup && typeof companySetup === 'object' ? companySetup : {};
  let list = setup.custom_names_for_invoice;
  if (typeof list === 'string') {
    try {
      list = JSON.parse(list);
    } catch (e) {
      list = null;
    }
  }
  return Array.isArray(list) ? list : [];
}

function collectButtonIds(buttonId: string | string[]): string[] {
  const ids: string[] = [];
  const primaryList = Array.isArray(buttonId) ? buttonId : [buttonId];
  for (let i = 0; i < primaryList.length; i++) {
    const id = primaryList[i];
    if (!id || ids.indexOf(id) >= 0) {
      continue;
    }
    ids.push(id);
    const aliases = INVOICE_BUTTON_ID_ALIASES[id];
    if (aliases) {
      for (let j = 0; j < aliases.length; j++) {
        if (aliases[j] && ids.indexOf(aliases[j]) < 0) {
          ids.push(aliases[j]);
        }
      }
    }
  }
  return ids;
}

function findInvoiceButtonEntry(list: any[], buttonId: string | string[]): any {
  const idsToTry = collectButtonIds(buttonId);
  for (let j = 0; j < idsToTry.length; j++) {
    for (let i = 0; i < list.length; i++) {
      if (list[i] && list[i].id === idsToTry[j]) {
        return list[i];
      }
    }
  }
  return null;
}

export function getInvoiceButtonLabel(
  buttonId: string | string[],
  defaultLabel: string,
  companySetup?: any
): string {
  const list = normalizeCustomNamesList(companySetup);
  if (!list.length) {
    return defaultLabel;
  }
  const entry = findInvoiceButtonEntry(list, buttonId);
  if (!entry) {
    return defaultLabel;
  }
  const isCustom = String(entry.is_custom) === '1';
  if (isCustom) {
    const custom = entry.custom_name;
    if (custom != null && String(custom).trim() !== '') {
      return String(custom).trim();
    }
  }
  if (entry.default_name != null && String(entry.default_name).trim() !== '') {
    return String(entry.default_name).trim();
  }
  return defaultLabel;
}



// WEBPACK FOOTER //
// /codebuild/output/src898022850/src/src/app/shared/utils/invoice-button-label.util.ts